const ConnectionCenterFields = [
  {
    id: Math.random() * 10,
    name: "Connection_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Center_Name",
        label: "Center Name",
        type: "text",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Managing_Branch",
        label: "Managing Branch",
        type: "text",
        min: 1,
        max: Infinity,
      },
    ],
  },
];

export { ConnectionCenterFields };
